/**
 * @file AddNewCountry.jsx
 * @author Rishikesh
 * @date 2024-09-18
 * @description Component of CountrySelection section to manage countries
 */
import { ContentPasteSearchOutlined } from "@mui/icons-material";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";

export const AddNewCountry = ({
  setNewCountry,
  newCountry,
  countryList,
  dialogOpen,
  handleDialogClose,
  handleUpdateCountryStatus,
}) => {
  const [dialogSearchQuery, setDialogSearchQuery] = React.useState("");

  const handleCheckboxChange = (country) => {
    setNewCountry((prev) => {
      const exists = prev.find((c) => c.id === country.id);
      if (exists) {
        return prev.map((c) =>
          c.id === country.id ? { ...c, isactive: c.isactive === 1 ? 0 : 1 } : c
        );
      } else {
        return [...prev, { ...country, isactive: 1 }];
      }
    });
  };

  const isChecked = (country) => {
    const found = newCountry?.find((c) => c.id === country.id);
    return found ? found.isactive === 1 : country.isactive === 1;
  };

  const filteredDialogCountries = countryList?.filter((item) =>
    item.country_name.toLowerCase().includes(dialogSearchQuery.toLowerCase())
  );

  return (
    <Dialog open={dialogOpen} onClose={handleDialogClose} fullWidth>
      <DialogTitle>Manage Country</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          label="Search Countries"
          fullWidth
          variant="outlined"
          value={dialogSearchQuery}
          onChange={(e) => setDialogSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <ContentPasteSearchOutlined />
              </InputAdornment>
            ),
          }}
          sx={{ mb: 2 }}
        />
        <Typography variant="subtitle1">Select Existing Countries</Typography>
        {filteredDialogCountries.map((item) => (
          <FormControlLabel
            key={item.id}
            control={
              <Checkbox
                checked={isChecked(item)}
                onChange={() => handleCheckboxChange(item)}
              />
            }
            label={item.country_name}
          />
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDialogClose}>Cancel</Button>
        <Button onClick={handleUpdateCountryStatus}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};
